var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import './NxRadio.scss';
import { propTypes } from './types';
var NxRadio = forwardRef(function NxRadio(_a, ref) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, isChecked = _a.isChecked, disabled = _a.disabled, children = _a.children, radioId = _a.radioId, otherProps = __rest(_a, ["name", "value", "onChange", "isChecked", "disabled", "children", "radioId"]);
    var labelClasses = classnames('nx-radio', {
        'nx-radio--disabled': disabled,
        'tm-checked': isChecked,
        'tm-unchecked': !isChecked
    });
    return (React.createElement("label", __assign({}, otherProps, { ref: ref, className: labelClasses }),
        React.createElement("input", { className: "nx-radio__input", id: radioId || undefined, type: "radio", name: name, disabled: !!disabled, checked: isChecked, onChange: function () { return onChange && onChange(value); }, readOnly: !onChange }),
        React.createElement("svg", { className: "nx-radio__circle", viewBox: "-8 -8 16 16" },
            React.createElement("circle", { r: "7", strokeWidth: "1", fill: "none", className: "nx-radio__outer-circle" }),
            isChecked && React.createElement("circle", { r: "5", stroke: "none", className: "nx-radio__inner-circle" })),
        children && React.createElement("span", { className: "nx-radio__content" }, children)));
});
NxRadio.propTypes = propTypes;
export default NxRadio;
//# sourceMappingURL=NxRadio.js.map